// @ts-nocheck
import React from 'react';

interface Game {
  _id?: string;
  timeSlot?: string;
  homeTeam?: string;
  awayTeam?: string;
  division: string;
  date?: string;
  globalDate?: string; // MM-DD-YYYY format
  time: string;
  location?: string;
  locationModel?: string;
  slotSectionId?: string; // Track which slot section this game belongs to
  duration?: number; // Duration in minutes
}

interface Division {
  _id: string;
  name: string;
  sports: string[];
  config?: {
    gameDurationInMinutes?: number;
  };
}

interface GameSlotProps {
  game: Game;
  divisions: Division[];
  formatTimeForDisplay: (timeString: string) => string;
  variant?: 'withTimeSlot' | 'withoutTimeSlot';
}

export const GameSlot: React.FC<GameSlotProps> = ({ 
  game, 
  divisions, 
  formatTimeForDisplay, 
  variant = 'withTimeSlot' 
}) => {
  const borderColor = variant === 'withTimeSlot' ? 'border-success/30 bg-success/10' : 'border-warning/30 bg-warning/10';
  const textColor = variant === 'withTimeSlot' ? 'text-success' : 'text-warning';

  return (
    <div className={`p-2 border rounded ${borderColor} mb-1`}>
      <div className={`text-xs ${textColor} font-medium mb-1`}>
        {game.location}
      </div>
      <div className="text-xs text-foreground">
        <div className="font-medium">
          {(game.homeTeam as any)?.name || 'TBD'} vs {(game.awayTeam as any)?.name || 'TBD'}
        </div>
        {game.time && (
          <div className="text-primary font-medium">
            {formatTimeForDisplay(game.time)}
          </div>
        )}
        <div className="text-muted-foreground">
          {divisions.find(d => d._id === game.division)?.name}
        </div>
      </div>
    </div>
  );
};

export default GameSlot;
